import InsuranceCheckPage from "./InsuranceCheckPage"

export default InsuranceCheckPage
